import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import {
  ModalOverlay,
  ModalCard,
  ModalCloseIcon,
  Text,
  ButtonRow,
  StyledCol,
} from "./styles";
import Button from "components/button";

const modalRoot = document.getElementById("root");
class ModalPortal extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
    this.el.className = "modal-portal";
  }
  componentDidMount() {
    modalRoot.appendChild(this.el);
  }
  componentWillUnmount() {
    modalRoot.removeChild(this.el);
  }
  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

export const ModalContext = React.createContext({ closeModal: () => {} });

const Modal = ({ children, closeOnClickAway = true, onClose = () => {} }) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setVisible(true);
    return () => setVisible(false);
  }, []);
  function close() {
    onClose();
    setVisible(false);
  }
  return visible ? (
    <ModalPortal>
      <ModalOverlay onClick={closeOnClickAway ? close : () => {}} />
      <ModalContext.Provider value={{ closeModal: close }}>
        {children}
      </ModalContext.Provider>
    </ModalPortal>
  ) : null;
};
export default Modal;

/**
 * White card centered on screen with close icon
 * @param {bool} showCloseIcon Control visibility of close icon
 */
export const ModalContent = ({ children, showCloseIcon = true, ...rest }) => (
  <ModalContext.Consumer>
    {({ closeModal }) => (
      <ModalCard {...rest}>
        {showCloseIcon && (
          <ModalCloseIcon
            src={require("assets/images/modal-close-icon.svg")}
            onClick={() => closeModal()}
          />
        )}

        {children}
      </ModalCard>
    )}
  </ModalContext.Consumer>
);

export const ConfirmModal = ({ text, onConfirm, onCancel = () => {} }) => (
  <ModalContext.Consumer>
    {({ closeModal }) => (
      <ModalContent>
        <StyledCol>
          <Text>{text}</Text>
          <ButtonRow>
            <Button onClick={() => onConfirm({ closeModal })}>Yes</Button>
            <Button
              onClick={() => {
                onCancel();
                closeModal();
              }}
              variant="zltoDarkBlue"
            >
              No
            </Button>
          </ButtonRow>
        </StyledCol>
      </ModalContent>
    )}
  </ModalContext.Consumer>
);
